export const CASES = {
  UPDATE_TPR_EXCEPTIONS: "UPDATE_TPR_EXCEPTIONS",
  UPDATE_TPR_EXCEPTIONS_SEARCH_FORM: "UPDATE_TPR_EXCEPTIONS_SEARCH_FORM",
  CLEAR_TPR_EXCEPTIONS: "CLEAR_TPR_EXCEPTIONS",
};
